import { lightColors } from '@/plugins/colors/base/baseColorsLight'
import borderTokensLight from '@/plugins/colors/tokens/light/sections/border'
import textTokensLight from '@/plugins/colors/tokens/light/sections/text'
import iconTokensLight from '@/plugins/colors/tokens/light/sections/icon'

const inputTokensLight = {
  'input-background-default': lightColors.gray.white,
  'input-background-disabled': lightColors.gray['20'],
  'input-border-default': lightColors.gray['100'],
  'input-border-focused': borderTokensLight['border-brand'],
  'input-border-disabled': lightColors.gray.white,
  'input-border-error': lightColors.red['500'],
  'input-border-success': lightColors.green['500'],
  'input-foreground-placeholder': lightColors.gray['300'],
  'input-foreground-typed': textTokensLight['text-primary'],
  'input-foreground-additional': textTokensLight['text-additional'],
  'input-foreground-disabled': textTokensLight['text-additional'],
  'input-foreground-error': textTokensLight['text-error'],
  'input-foreground-success': textTokensLight['text-success'],
  'input-label-default': textTokensLight['text-primary'],
  'input-label-additional': iconTokensLight['icon-additional'],
  'input-label-disabled': textTokensLight['text-disabled']
}

export default inputTokensLight
